import React, { useEffect, useState } from "react";
import { Container, Button, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import TopNav from "./TopNav";
import SideBar from "./SideBar"; // Assuming this contains the sidebar component
import { API_URL } from "./config";

function SaleHistory() {
  const [salesData, setSalesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const companyId = localStorage.getItem("async_client_profile_id");
  const branchId = localStorage.getItem("branchId");
  const shiftId = localStorage.getItem("shiftId");


  useEffect(() => {
    async function fetchSalesData() {

      
      const url = `${API_URL}/salepostrans/get_sale_pos_trans_sold_by_shift/19/30/7`;
  
      try {
          const response = await fetch(url, {
              method: 'GET',
              headers: {
                  'Content-Type': 'application/json',
              },
          });
  
          if (!response.ok) {
              throw new Error('Network response was not ok');
          }
  
          const data = await response.json();
          console.log("Fetched Sales Data:", data);
          console.log("Company Id", companyId);
          console.log("Branch Id", branchId);
          console.log("Shift Id", shiftId);
          setSalesData(data);
      } catch (error) {
          console.error('Error fetching sales data:', error);
          setError(error.message);
      } finally {
          setLoading(false);
      }
    }

    fetchSalesData();
    console.log("company_id",companyId,branchId,shiftId);
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      <TopNav />
      <Row>
        <Col md={3} className="sidebar">
          <SideBar />
        </Col>
        <Col md={9}>
          <Container>
            <header className="text-center my-4">
              <h1>Rems POS</h1>
              <h1 className="">Sales History</h1>
            </header>
            
            <div className="sales-list">
  {salesData.length > 0 ? (
    <table className="table table-bordered">
      <thead>
        <tr>
          <th>Date</th>
          <th>Product Name</th>
          <th>Product Type</th>
          <th>Unit Size</th>
          
          <th>Unit Cost</th>
          <th>Amount</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {salesData.map((sale) => (
          <tr key={sale.payid} style={{ backgroundColor: 'white' }}>
            <td>{new Date(sale.daterec).toLocaleString()}</td>
            <td><strong>{sale.product_name}</strong></td>
            <td>{sale.product_type}</td>
            <td>{sale.unit_size} {sale.unit_of_measure}</td>
            
            <td>{sale.unit_cost}</td>
            <td>{sale.amount}</td>
            <td>
              <Button variant="primary">
                <Link to={`/sale/${sale.payid}`} style={{ color: "inherit", textDecoration: "none" }}>
                  View Details
                </Link>
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <div className="text-center">No sales data available.</div>
  )}
</div>
          </Container>
        </Col>
      </Row>
    </div>
  );
}

export default SaleHistory;